"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WildcardOption = void 0;
var WildcardOption;
(function (WildcardOption) {
    WildcardOption["NONE"] = "NONE";
    WildcardOption["LOW_HOLE"] = "LOW_HOLE";
    WildcardOption["LOW_HOLE_WITH_BUY"] = "LOW_HOLE_WITH_BUY";
    WildcardOption["CENTER_CARD"] = "CENTER_CARD";
    WildcardOption["DEUCES"] = "DEUCES";
    WildcardOption["ONE_EYED_JACKS"] = "ONE_EYED_JACKS";
    WildcardOption["QUEENS_AND_FOLLOWERS"] = "QUEENS_AND_FOLLOWERS";
})(WildcardOption || (exports.WildcardOption = WildcardOption = {}));
//# sourceMappingURL=WildcardOption.js.map